<template>
  <div id="declare" class="declare">
    <div class="header">
      <div class="logoWrap">
        <img class="logo" src="/img/logoBg.png" alt="">
        <p class="logoName">建筑应用创新大奖</p>
        <p class="logoNameEn">ARCHITECTURAL APPLICATION INNOVATION AWARD</p>
        <span v-if="gIsLogin('login_time')" @click="logout" class="logout">退出登录</span>
      </div>
      <div class="pageName">
        <span class="bigName">项目申报系统</span>
        <router-link class="website" to="/award/index" target="_blank">大奖官网</router-link>
      </div>
    </div>
    <div class="content">
      <div class="navLeft">
        <p><router-link class="nav" to="/declaration_system/company_information">参评单位信息</router-link></p>
        <p><router-link class="nav" to="/declaration_system/project_information">参评项目信息</router-link></p>
        <p><router-link class="nav" to="/declaration_system/data_download">资料下载</router-link></p>
      </div>
      <div class="contentRight"><router-view></router-view></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");
      this.$router.push("/registration_system/login/declaration");
    }
  }
};
</script>

<style lang="scss" scoped>
.declare {
  background: #f3f3f3;
  padding-bottom: 100px;

  .content {
    min-width: 1200px;
    position: relative;
    padding: 50px 160px 0 250px;
    .navLeft {
      position: absolute;
      width: 130px;
      left: 100px;
      top: 50px;
      background: rgba($color: #fff, $alpha: 0.7);
      padding: 10px 15px;
      border-radius: 5px;
      .nav {
        color: #3f4641;
        padding: 5px 0;
        display: inline-block;
        margin: 5px 0;
      }
      .router-link-active {
        color: #277a44;
        position: relative;
      }
      .router-link-active::after {
        content: "";
        position: absolute;
        right: -8px;
        top: 12px;
        height: 15px;
        border-right: 2px solid #277a44;
      }
    }
    .contentRight {
      min-height: 300px;
      padding: 30px 30px 60px;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 0 16px rgba($color: #fff, $alpha: 0.4);
    }
  }
}
</style>